import styled from "styled-components";
import { spacing } from "@styling/sizing";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${spacing.x2}px;

  @media (max-width: 768px) {
    gap: ${spacing.x1}px;
  }
`;
